import React, { Component } from 'react';
import { Button } from 'antd';
import { hashHistory } from 'react-router';

import PageHeader from '../../components/Modules/PageHeader';
import FilterPanel from "../../components/Modules/FilterPanel";
import Content from './Content';

import './eventEditor.less'

export default class EventEditor extends Component {
  saveNewEvent() {
    this.setState({newEvent: false})
  }

  setStateHandler = (obj) => {
    this.setState(obj)
  }

  render(){
    const { channels, events, user, params } = this.props;
    const { userClaims, uid } = user;
    const { eventId } = params;

    let eventEdit = {};
    if (eventId && events) {
      eventEdit = events.find(event => event.id === eventId)
    }
    
    const isShownOrNot = !uid || (uid && !userClaims.userType);
    if (isShownOrNot) {
      hashHistory.push(`/Channels`);
    }
    
    return (
      <React.Fragment>
        <PageHeader
          className="header"
          title={eventId && eventEdit ? "Edit Event" : "Create Event"}
          extra={
            <div className="search-form">
              <FilterPanel 
                filter={this.filterBy} 
                title="Event search" 
                type="event"
                deviceType
              />
            </div>
          }
          extraMobile={
            <Button type="primary" shape="circle" icon="search" />
          }
          mobileTitleSearch="Event search"
          mobileTypeSearch="event"
        />
        <Content 
          eventId={eventId}
          events={events}
          channels={channels}
          userClaims={userClaims}
        />
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/EventEditor/index.js